import { SET_COUNTRY_CODES } from "../Actions/types";

const INITIAL_STATE = [];

const countryCodesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_COUNTRY_CODES:
      return action.payload;
    default:
      return state;
  }
};

export default countryCodesReducer;
